import { createStyles } from '@mantine/styles';

export default createStyles(() => ({
  dropdown: {},

  itemsWrapper: {
    padding: 4,
    display: 'flex',
    width: '100%',
    boxSizing: 'border-box',
  },
}));
